
import Breadcrumbs from "~/components/UI/Breadcrumbs";
import CargoRateCalculator from "~/pages/cargo-rate-calculator/index";
import {formaterOgTitle} from "~/helpers/formaterOgTitle";

export default {
  name: "index",

  fetch: async function () {
    await this.getCmsContent();
    await this.$store.dispatch("routes/getCities");
    await this.$store.dispatch("routes/getPopularRoutes");
  },

  head: function () {
    const title = this.seoPage?.title || `Грузоперевозки по России ${ this.userCity }`;
    const description = this.seoPage?.description || `Компания Central Trans осуществляет перевозки по всем возможным направлениям в России, ЛНД, ДНР и странам СНГ. Оставьте заявку и наши менеджеры свяжутся с Вами для консультации`

    return {
      title: title,
      meta: [
        {name: 'og:title', hid: 'og:title', property: 'og:title', content: formaterOgTitle(title, this.$store.state.appState.config)},

        {hid: 'metadescription', name: 'description', content: description},
        {hid: 'og:description', name: 'og:description', property: 'og:description', content: description}
      ],
    }
  },

  data: function () {
    return {
      seoPage: {
        h1: "",
        title: "",
        description: ""
      }
    }
  },

  computed: {
    breadcrumbs: function () {
      return [
        { title: "Главная", path: "/" },
        { title: this.seoPage?.h1, path: this.$route.path },
      ]
    },

    cities: function () {
      return this.$store.state.routes.cities || []
    },
    popularRoutes: function () {
      return this.$store.state.routes.popularRoutes || []
    },
    userCity: function () {
      const city = this.$store.state?.appState?.config?.city?.data?.parental || this.$store.state?.appState?.config?.city?.data?.city_name;

      return `из ${city}`
    },

    isLoadCities: function () {
      return this.$store.state.routes.isLoadCities
    },
    isLoadPopularRoutes: function () {
      return this.$store.state.routes.isLoadPopularRoutes
    },
  },

  components: {
    Breadcrumbs,
    CargoRateCalculator,

    PopularRoutes: () => import("~/components/routes/PopularRoutes"),
    DepartureCities: () => import("~/components/routes/DepartureCities")
  },

  methods: {
    getCmsContent: async function () {
      const repsonse = await this.$api.agent.transport.get("/cms/page-by-path?path=/routes").then((res) => {
        return res.data
      }).catch(() => {
        return null
      });
      if (!repsonse) {
        return
      }

      this.seoPage = {
        h1: repsonse?.page?.title || "",
        title: (repsonse?.page?.title_tag || '').replace("$city", this.userCity),
        description: repsonse?.page?.description || "",
      }
    },
    openFormSubmitApplication: function () {
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          title: "Оставить заявку",
          activeTab: "big",
          hideTabs: true,
          type: 'Оставить заявку',
          fullReachGoal: "calculate_cost_submit_request_calculator"
        }
      });
    },
  }
}
